import React from 'react';

export default function OrderMultipliers() {
  return (
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Order_Multipliers__ZJFy9g5cTr61BWm9uQkUjg"
      height="640"
      title="Order Multipliers"
      allowFullScreen
    />
  );
}
